import _extends from "@babel/runtime/helpers/extends";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.57;\n  color: ", ";\n  margin-bottom: 8px;\n\n  ", "\n\n  ", "\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    position: relative;\n    box-sizing: border-box;\n    width: 320px;\n    height: 44px;\n    border-radius: ", ";\n    font-size: 14px;\n    color: ", ";\n    border: 1px solid ", ";\n    transition: border-color 250ms ease-in-out;\n\n    &:focus,\n    &:hover {\n      outline: 0;\n      border-color: ", ";\n    }\n\n    &:disabled {\n      opacity: 0.3;\n      color: ", ";\n\n      &:hover {\n        border-color: ", ";\n      }\n    }\n\n    ", "\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: left;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { useMemo } from 'react';
import { v4 as uuid } from 'uuid';
import styled, { css } from '../../utils/styling/styled-components';
import { TEXT_INPUT_ERROR, TEXT_INPUT_LABEL } from '../../utils/testing/TestIDs';
import { ErrorLabel } from './ErrorLabel';
var Container = styled.div(_templateObject());
var AdornmentContainer = styled.div(_templateObject2());
var DecoratorContainer = styled.div(_templateObject3());
var Input = styled.input(function (props) {
  return css(_templateObject4(), props.theme.borderRadius.large, props.theme.colors.slate, props.theme.colors.stoneLight, props.theme.colors.stone, props.theme.colors.stone, props.theme.colors.stoneLight, props['data-error'] && "\n      border-color: ".concat(props.theme.colors.red, ";\n      color: ").concat(props.theme.colors.red, ";\n\n      &:focus, &:hover {\n        border-color: ").concat(props.theme.colors.red, ";\n      }\n    "));
});
var Label = styled.label(_templateObject5(), function (props) {
  return props.theme.colors.slate;
}, function (props) {
  return props.disabled && "\n      opacity: 0.3;\n    ";
}, function (props) {
  return props.hidden && "\n      border: 0;\n      clip: rect(0 0 0 0);\n      height: 1px;\n      margin: -1px;\n      overflow: hidden;\n      padding: 0;\n      position: absolute;\n      width: 1px;\n    ";
});

var BaseTextInputV2 = function BaseTextInputV2(_ref) {
  var className = _ref.className,
      adornments = _ref.adornments,
      error = _ref.error,
      errorText = _ref.errorText,
      decorators = _ref.decorators,
      inputProps = _ref.inputProps,
      label = _ref.label,
      ref = _ref.ref;
  var inputID = useMemo(function () {
    return (inputProps === null || inputProps === void 0 ? void 0 : inputProps.id) || uuid();
  }, [inputProps === null || inputProps === void 0 ? void 0 : inputProps.id]);
  return /*#__PURE__*/React.createElement(Container, {
    className: className
  }, /*#__PURE__*/React.createElement(Label, {
    htmlFor: inputID,
    "data-testid": TEXT_INPUT_LABEL,
    disabled: inputProps.disabled,
    hidden: label.hidden || !label.value
  }, label.value), decorators === null || decorators === void 0 ? void 0 : decorators.top, /*#__PURE__*/React.createElement(DecoratorContainer, null, decorators === null || decorators === void 0 ? void 0 : decorators.left, /*#__PURE__*/React.createElement(AdornmentContainer, null, (adornments === null || adornments === void 0 ? void 0 : adornments.left) && adornments.left, /*#__PURE__*/React.createElement(Input, _extends({
    "data-error": error
  }, inputProps, {
    id: inputID,
    ref: ref
  })), (adornments === null || adornments === void 0 ? void 0 : adornments.right) && adornments.right), decorators === null || decorators === void 0 ? void 0 : decorators.right), errorText && /*#__PURE__*/React.createElement(ErrorLabel, {
    "data-testid": TEXT_INPUT_ERROR,
    fieldId: inputID,
    errorText: errorText
  }), decorators === null || decorators === void 0 ? void 0 : decorators.bottom);
};

export { BaseTextInputV2 };